import { buildHeaderSearchItemsFromRows } from './headerSearchFilter';

export const UPCOMING_SEARCH_CACHE_MS = 3 * 60 * 1000;
export const UPCOMING_SEARCH_FETCH_LIMIT = 200;

let cache = { loadedAt: 0, items: [] };

export function getCachedUpcomingSearchItems() {
  return cache.items;
}

/**
 * Load (or return cached) flat trek rows for header + events search — same dataset as the top bar.
 */
export async function ensureUpcomingSearchIndex(dynamicAPI, { forceRefresh = false } = {}) {
  const stale =
    forceRefresh ||
    !cache.items.length ||
    Date.now() - cache.loadedAt > UPCOMING_SEARCH_CACHE_MS;
  if (!stale) return cache.items;

  const response = await dynamicAPI.getUpcomingTreks({ limit: UPCOMING_SEARCH_FETCH_LIMIT });
  const rows = Array.isArray(response.data?.data) ? response.data.data : [];
  cache = {
    loadedAt: Date.now(),
    items: buildHeaderSearchItemsFromRows(rows)
  };
  return cache.items;
}
